<h1 matDialogTitle>Invoice EFT Refund Request</h1>

<mat-dialog-content>
  <div>
    <table style="width: 100%;">
      <tr>
        <th rowspan="2" class="th-label" style="vertical-align: top;">Invoice</th>
        <td rowspan="2" class="td-value" style="text-align: right; padding-right: 16px;vertical-align: top;">{{invoice.invoiceNumber}}</td>
        <th class="th-label">Total</th>
        <td class="td-value" style="text-align: right;">{{invoice.invoiceAmount | number:'1.2-2'}}</td>
      </tr>
      <tr>
        <!-- <th class="th-label">Invoice</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{invoice.invoiceNumber}}</td> -->
        <th class="th-label">Balance</th>
        <td class="td-value" style="text-align: right;">{{invoice.invoiceBalance | number:'1.2-2'}}</td>
      </tr>
      <tr>
        <th class="th-label">Sales Order</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{invoice.salesOrderNumber}}</td>
        <th class="th-label">Balance (Dep.)</th>
        <td class="td-value" style="text-align: right;">{{invoice.depositBalance | number:'1.2-2'}}</td>
      </tr>
      <tr>
        <th class="th-label">Customer</th>
        <td class="td-value" style="text-align: right; padding-right: 16px;">{{invoice.customerCode}}</td>
        <th class="th-label">Balance (Acc.)</th>
        <td class="td-value" style="text-align: right;">{{invoice.customerAccountBalance | number:'1.2-2'}}</td>
      </tr>

    </table>
  </div>

  <form class="dynamic-form" [formGroup]="form" style="width: 100%;margin-top: 16px">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="100" width="100%">
        <mat-select formControlName="storeId" placeholder="Store">
          <mat-option *ngFor="let store of stores" [value]="store.storeId">{{store.storeName}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field fxFlex="50" width="100%">
        <mat-label>Amount</mat-label>
        <input matInput style="text-align: right;" type="number" formControlName="amount" autocomplete="new-password"
        (keyup)="amountTenderedChanged()" (focusout)="amountTenderedFocusOut()">
      </mat-form-field>

      <ng-container *ngIf="banks && banks.length > 0; else bankInputs">
        <mat-form-field fxFlex="100" width="100%">
          <mat-select  placeholder="Bank" (selectionChange)="onBankSelectionChange($event)">
            <mat-option *ngFor="let bank of banks" [value]="bank">{{bank.bankDisplay}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>

      <ng-template #bankInputs>
        <mat-form-field fxFlex="100" width="100%"  [hidden]="true">
          <mat-label>Bank</mat-label>
          <input matInput type="text" #bank formControlName="bank" maxlength="50"
            autocomplete="new-password">
          <mat-hint align="end">{{bank.value.length}} / 50</mat-hint>
        </mat-form-field>

        <mat-form-field fxFlex="100" width="100%">
          <mat-label>Branch Code</mat-label>
          <input matInput type="text" #branchCode formControlName="branchCode" maxlength="10"
            autocomplete="new-password">
          <mat-hint align="end">{{branchCode.value.length}} / 10</mat-hint>
        </mat-form-field>
      </ng-template>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Account Number</mat-label>
        <input matInput type="text" #accountNumber formControlName="accountNumber" maxlength="20"
          autocomplete="new-password">
        <mat-hint align="end">{{accountNumber.value.length}} / 20</mat-hint>
      </mat-form-field>


      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Refund Reason</mat-label>
        <mat-select formControlName="refundReasonId">
          <mat-option *ngFor="let refundReason of refundReasons" [value]="refundReason.refundReasonId">
            {{refundReason.refundReasonDesc}}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Comment</mat-label>
        <textarea matInput rows="2" style="text-align: left;" type="text" minlength="1" maxlength="200" formControlName="comment" autocomplete="new-password"></textarea>
      </mat-form-field>

    </div>
  </form>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [matDialogClose]="undefined">Cancel</button>
  <button [disabled]="!form.valid" mat-button (click)="save()">Save</button>
</mat-dialog-actions>
